export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item) && item !== null;
}

export default function merge(target, source) {
  let output = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) Object.assign(output, { [key]: source[key] });
        else output[key] = merge(target[key], source[key]);
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
}



// WEBPACK FOOTER //
// ./src/common/utils/merge.js